import _ from 'lodash';
import moment from 'moment';
import momenttz from 'moment-timezone';

function _convertTimesToMomentAndDuration(object) {
  const copy = _.cloneDeep(object);

  if (object.dateTime) {
    copy.dateTime = moment(object.dateTime);
  }

  if (object.startDateTime) {
    copy.startDateTime = moment(object.startDateTime);
  }

  if (object.endDateTime) {
    copy.endDateTime = moment(object.endDateTime);
  }

  if (object.duration) {
    copy.duration = moment.duration(object.duration, 'minutes');
  }

  return copy;
}

// this function converts the dateTime elements in
// an object or collection of objects into moments
export function mapDateTimesToMoments(arrayOfObjects) {
  if (arrayOfObjects) {
    if (_.isArray(arrayOfObjects)) {
      return arrayOfObjects.map(objectWithTime => {
        return _convertTimesToMomentAndDuration(objectWithTime);
      });
    }

    return _convertTimesToMomentAndDuration(arrayOfObjects);
  }
  return arrayOfObjects;
}

export function removeTimeFromMoments(date) {
  const dateFormatter = 'YYYY-MM-DD';
  return moment(date.format(dateFormatter), dateFormatter);
}

// Takes appointment time strings from OnSched like 2019-01-28T13:00:00-06:00
// and converts to Jan 28th 2019, 1:00pm
export function prettyAppointmentTime(appointmentTimeString) {
  return moment
    .parseZone(appointmentTimeString, 'YYYY-MM-DDTHH:mm:ssZZ')
    .format('MMM Do YYYY, h:mma');
}

export function prettyAppointmentTimeLocalized(appointmentTimeString, ianaTimezone) {
  return momenttz.utc(appointmentTimeString).tz(ianaTimezone).format('MMM Do YYYY, h:mma');
}

export function compactDateTime(appointmentTimeString) {
  return moment
    .parseZone(appointmentTimeString, 'YYYY-MM-DDTHH:mm:ssZZ')
    .format('MM/DD/YYYY h:mma');
}



// WEBPACK FOOTER //
// ./src/utils/timeUtils.js